import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { useUpdateRateMutation } from 'queries/wage/useUpdateRateMutation'
import { parseErrorMessage } from 'api'

type EditRateFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useUpdateRateMutation>['mutate']
  }
}

const [Context, useEditRateFlowContextValue] =
  createContext<EditRateFlowContextState>({
    name: 'EditRateFlowContext',
  })

export const EditRateFlowProvider = ({
  children,
  ruleId,
}: PropsWithChildren<{ ruleId: number }>) => {
  const { mutate, isPending, error } = useUpdateRateMutation(ruleId)

  const value: EditRateFlowContextState = {
    state: {
      mutationState: {
        isPending,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: { submit: mutate },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useEditRateFlowContextValue }
